import * as React from 'react';
import { DefaultButton, Dropdown, type IDropdownOption, PrimaryButton, ProgressIndicator } from '@fluentui/react';
import styles from './SharePointOrganizer.module.scss';
import type { ILibraryInfo } from '../../../models/LibraryInfo';
import { formatNumber } from '../../../utils/format';

export interface ILibrarySelectorProps {
  libraries: ILibraryInfo[];
  selectedId: string | undefined;
  scanning: boolean;
  itemsRead: number;
  onSelect: (id: string) => void;
  onScan: () => void;
  onCancel: () => void;
}

export default function LibrarySelector(props: ILibrarySelectorProps): React.ReactElement {
  const { libraries, selectedId, scanning, itemsRead, onSelect, onScan, onCancel } = props;
  const options: IDropdownOption[] = libraries.map(l => ({ key: l.id, text: l.name }));

  return (
    <div className={styles.selector}>
      <div className={styles.selectorRow}>
        <Dropdown
          className={styles.libraryDropdown}
          label="Document library"
          options={options}
          selectedKey={selectedId}
          disabled={scanning}
          onChange={(_, option) => option && onSelect(String(option.key))}
        />
        {scanning
          ? <DefaultButton text="Cancel" onClick={onCancel} />
          : <PrimaryButton text="Scan Library" iconProps={{ iconName: 'Search' }} disabled={!selectedId} onClick={onScan} />}
      </div>
      {scanning && (
        <ProgressIndicator
          label="Scanning…"
          description={`${formatNumber(itemsRead)} files and folders read. Only names and details are read — no file contents.`}
        />
      )}
    </div>
  );
}
